import { morphism } from 'morphism';
import { createStrictSchema } from '../../utils/morph.js';
import { itemSchema, gallerizedItemSchema } from '../ads/morph.js';

const searchSchemaObj = createStrictSchema({
    total: 'count_all',
    checkNew: 'checknew',
    lines: 'lines',
    start: 'start',
    ads: {
        path: 'ads',
        fn: morphism(itemSchema),
    },
    filterLabels: 'filters',
});
const searchSchema = createStrictSchema(searchSchemaObj);
const gallerizedSearchSchema = createStrictSchema({
    ...searchSchemaObj,
    ads: {
        path: 'ads',
        fn: morphism(gallerizedItemSchema),
    },
});
const searchRecommendedSchema = createStrictSchema({
    count: 'count',
    filters: 'filters',
});
const filterValuesSchema = createStrictSchema({
    values: 'values',
    topValues: 'top_values',
});
const savedSearchSchema = createStrictSchema({
    filters: 'filters',
    searchId: 'search_id',
    insertionDate: 'insertion_date',
    updateDate: 'update_date',
    premiumExpirationDate: 'premium_expiration_date',
    sort: 'sort',
});
const savedSearchesSchema = createStrictSchema({
    savedSearches: {
        path: 'saved_searches',
        fn: morphism(savedSearchSchema),
    },
});
const listFilterSchemaObj = {
    uri: 'uri',
    type: 'type',
    label: 'label',
    dataSource: 'datasource',
    queryString: 'query_string',
    dependencies: 'dependencies',
    multiSelection: 'multiselection',
    searchable: 'searchable',
};
const listFilterSchema = createStrictSchema(listFilterSchemaObj);
const compositeFilterSchema = createStrictSchema({
    ...listFilterSchemaObj,
    subLabel: 'sublabel',
    min: {
        path: 'min',
        fn: morphism(listFilterSchema),
    },
    max: {
        path: 'max',
        fn: morphism(listFilterSchema),
    },
});
const filterConfigSchema = createStrictSchema({
    filters: {
        path: 'filters',
        fn: morphism(compositeFilterSchema),
    },
});

export { filterConfigSchema, filterValuesSchema, gallerizedSearchSchema, savedSearchSchema, savedSearchesSchema, searchRecommendedSchema, searchSchema };
//# sourceMappingURL=morph.js.map
